import { Lock, Crown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface ProToolLockProps {
  children: React.ReactNode;
  isPremium: boolean;
  requiredTier?: 'pro' | 'elite';
  userTier?: string | null;
}

const ProToolLock = ({ children, isPremium, requiredTier = 'pro', userTier }: ProToolLockProps) => {
  // Check if user has access based on tier hierarchy
  const hasAccess = isPremium && (
    userTier === 'elite' || 
    (requiredTier === 'pro' && (userTier === 'pro' || userTier === 'elite'))
  );

  if (hasAccess) {
    return <>{children}</>;
  }

  return (
    <div className="relative min-h-[60vh]">
      {/* Blurred content */}
      <div className="opacity-20 blur-sm pointer-events-none select-none">
        {children}
      </div>

      {/* Lock overlay */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="glass rounded-2xl p-8 text-center max-w-md border border-border/50 animate-fade-in">
          <div className="h-16 w-16 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-4">
            <Lock className="h-8 w-8 text-primary" />
          </div>
          <h2 className="text-2xl font-bold mb-2">Premium Feature</h2>
          <p className="text-muted-foreground mb-6">
            This tool is only available for TAM {requiredTier === 'elite' ? 'Elite' : 'Pro'} members.
            Upgrade your account to unlock exclusive features and tools.
          </p>
          <Link to="/dashboard/vault">
            <Button className="bg-primary hover:bg-primary/90">
              <Crown className="h-4 w-4 mr-2" />
              Upgrade to {requiredTier === 'elite' ? 'Elite' : 'Pro'}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProToolLock;